import React, { useContext } from 'react';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import { Button, Flex, Text } from 'pcln-design-system';
import { ChatBubble as ChatIcon } from 'pcln-icons';
import { useGoogleMapsHooks } from './useGoogleMapsHooks';
export default function GoogleMapComponents() {
  var _a;
  const {
    setOpenedMap,
    hotelOnMapList,
    locationPinList
  } = useContext(ChatbotDataContext);
  const hotelPinsOnMap = hotelOnMapList === null || hotelOnMapList === void 0 ? void 0 : hotelOnMapList.reduce((acc, curr) => {
    acc[curr.name] = Object.assign({}, curr);
    return acc;
  }, {});
  const locationPinsOnMap = (_a = locationPinList === null || locationPinList === void 0 ? void 0 : locationPinList.slice(0, 6)) === null || _a === void 0 ? void 0 : _a.reduce((acc, curr) => {
    acc[curr.name] = Object.assign({}, curr);
    return acc;
  }, {});
  useGoogleMapsHooks({
    pinsOnMap: Object.assign(Object.assign({}, hotelPinsOnMap), locationPinsOnMap)
  });
  return React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      height: 'calc(100% - 60px)',
      width: '100%'
    },
    id: 'PENNY-SEARCH-GOOGLE-MAP'
  }), React.createElement(Button, {
    size: 'small',
    style: {
      position: 'absolute',
      bottom: '0',
      left: '50%',
      transform: 'translate(-50%, -15px)'
    },
    onClick: function () {
      setOpenedMap(false);
    },
    title: 'Close Map'
  }, React.createElement(Flex, null, React.createElement(ChatIcon, {
    color: 'lightest',
    size: 16
  }), React.createElement(Text, {
    ml: 1
  }, "Chat"))));
}